import { FaArrowUpRightFromSquare, FaGithub } from 'react-icons/fa6';
import { Modal } from '../modal/modal';
import { ProjectProps } from './contracts/project-props';
import { isRepoLink } from '../link-utils';

export function Project(props: ProjectProps) {
  const repo = isRepoLink(props.link);

  const openModal = () => {
    const dialog = document.getElementById(props.id) as HTMLDialogElement | null;
    dialog?.showModal();
  };

  return (
    <>
      <button
        type="button"
        onClick={openModal}
        className="terminal-card group flex h-full flex-col overflow-hidden text-left transition-all duration-200 hover:-translate-y-1 hover:border-accent/60"
      >
        <div className="relative aspect-[16/9] w-full overflow-hidden border-b border-border bg-elevated">
          {props.logo ? (
            <img
              src={props.logo}
              alt={props.title ?? 'project'}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center font-mono text-4xl text-border">
              {'</>'}
            </div>
          )}
          {props.link && (
            <span className="absolute right-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-bg/80 px-2.5 py-1 font-mono text-xs text-accent backdrop-blur">
              {repo ? (
                <>
                  <FaGithub aria-hidden /> repo
                </>
              ) : (
                <>
                  <span className="h-1.5 w-1.5 rounded-full bg-accent" /> live
                </>
              )}
            </span>
          )}
        </div>

        <div className="flex flex-1 flex-col p-5">
          <h3 className="flex items-center gap-2 font-mono text-lg font-medium text-fg">
            {props.title}
            {props.link && (
              <FaArrowUpRightFromSquare
                aria-hidden
                className="text-xs text-muted opacity-0 transition-opacity group-hover:opacity-100"
              />
            )}
          </h3>
          <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-muted">{props.excerpt}</p>
        </div>
      </button>

      <Modal
        id={props.id}
        title={props.title}
        mainInfo={props.description ?? props.excerpt}
        image={props.logo}
        link={props.link}
        blogSlug={props.blogSlug}
      />
    </>
  );
}
